import React from "react";
import { connect } from "react-redux";
import { getNGSGroupCustomerClaimsRequest } from "./redux/actions";
import Claims from "./Components/Claims/Claims";
import { getAllPoliciesRequest } from "../../Redux/actions";
class NGSGroupClaims extends React.Component {
  constructor(props) {
    super(props);
    this.state = {

    }
  }

  componentWillMount() {
    const currentCustomer = this.props.customerData.currentCustomer;
    if (currentCustomer) {
      this.props.dispatch(getNGSGroupCustomerClaimsRequest({ guid: currentCustomer.guid }));
      this.props.dispatch(getAllPoliciesRequest({ guid: currentCustomer.guid }))
    }
  }



  render() {

    return (
      <>
       <Claims
       claims={this.props.NGSGroupClaimsData.claims}
       loader={this.props.NGSGroupClaimsData.get_claims_loader}
       />
      </>
    )


  }
}

export default connect((state) => ({
  customerData: state.currentCustomer,
  customerScreenData: state.customerScreen,
  NGSGroupClaimsData: state.NGSGroupClaimsData
}))(NGSGroupClaims);